import { ReactNode } from 'react'

import Card from 'app/frontend/base/components/Card'

type TimelineAbilitySectionProps = {
  title: ReactNode
  labels: ReactNode
  timeline: ReactNode
  labelsInCard?: boolean
  titleAction?: ReactNode
  onTimelineMouseMove?: (event: React.MouseEvent<HTMLDivElement>) => void
  onTimelineMouseLeave?: () => void
}

const TimelineAbilitySection = ({
  title,
  labels,
  timeline,
  labelsInCard = true,
  titleAction,
  onTimelineMouseMove,
  onTimelineMouseLeave,
}: TimelineAbilitySectionProps) => {
  return (
    <div className='relative z-10 flex items-start gap-1 group'>
      <div className='w-40 shrink-0 min-w-0'>
        <div className='h-6 px-1 flex items-center'>
          <div className='min-w-0 w-full text-xs text-foreground truncate leading-[14px] relative'>
            {title}
          </div>
        </div>
        {labels ? (
          labelsInCard ? (
            <Card className='py-0 pl-1 pr-0 rounded-[8px] text-xs'>
              {labels}
            </Card>
          ) : (
            labels
          )
        ) : null}
      </div>
      <div className='grow min-w-0'>
        <div className='h-6 px-1 flex items-center justify-end'>
          {titleAction}
        </div>
        <div className='-mt-6'>
          <div
            onMouseMove={onTimelineMouseMove}
            onMouseLeave={onTimelineMouseLeave}
          >
            {timeline}
          </div>
        </div>
      </div>
    </div>
  )
}

export default TimelineAbilitySection
